import React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";

import theme from "../../../themes/theme.module.css";

// Large button with newer mui Button (v7).
const LargeSolidButton = ({ label, callback, sx }) => {
  const btnsx = {
    backgroundColor: theme.lake500,
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.lake600,
    },
    "&:active": {
      backgroundColor: theme.lake700,
    },
    ...sx,
  };

  return (
    <Button
      classes={{
        label: `${theme.actionTextLarge} ${theme.buttonTextLarge}`,
      }}
      size="large"
      type="button"
      variant="contained"
      onClick={callback}
      style={{
        fontFamily: "Public Sans, sans-serif",
        fontSize: 19,
        fontStyle: "normal",
        fontWeight: 700,
      }}
      sx={btnsx}
    >
      {label}
    </Button>
  );
};
export default LargeSolidButton;

LargeSolidButton.defaultProps = {
  sx: {},
};

LargeSolidButton.propTypes = {
  label: PropTypes.string.isRequired,
  callback: PropTypes.func.isRequired,
  sx: PropTypes.shape(),
};
